const TEXTS = {
  ERRORS: {
    HEADER: 'Algo salió mal -',
    LIMIT_EXCEEDED: 'Solo puede enviar 1 archivo',
    MIMETYPE_WRONG: 'Solo se aceptan archivos con extensión: '
  },
  HEADER: 'Arrastra y suelta un archivo',
  INPUT_FILE: 'Selecciona un archivo',
  SINGLE_INPUT_FILE: 'O selecciona un archivo'
};

export default TEXTS;
